import { render, staticRenderFns } from "./GameRecord.vue?vue&type=template&id=07a65751&scoped=true&"
import script from "./GameRecord.vue?vue&type=script&lang=ts&"
export * from "./GameRecord.vue?vue&type=script&lang=ts&"
import style0 from "./GameRecord.vue?vue&type=style&index=0&id=07a65751&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a65751",
  null
  
)

export default component.exports